import "./service-tile.css";

export interface ServiceTile {
  img: string;
  title: string;
}

export function ServiceTile({ img, title }: ServiceTile) {
  return (
    <div className='service-tile'>
      <img className='service-image' src={img} alt={title} />
      <div className='service-title'>{title}</div>
    </div>
  );
}
